import gql from 'graphql-tag'

const PLAYER_AND_USER_QUERY = gql`query($userId: Int!) {
    two_player(where:{user: {id: {_eq: $userId}}}){
        id
        nickname
        picture
        phone
        position_one{
            id
            name
            name_ar
        }
        position_two{
            id
            name
            name_ar
        }
        user{
            id
            name
            phone
            in_phone
            email
            gender
            nationality
            address
            date_of_birth
            is_deactivated
            coins
            extra_coins
            picture
            identification_number
            verified
        }
    }
}`;

const ALL_PITCH_QUERY = gql`{
    two_pitch(order_by:{name: asc}) {
        id
        name
        description
        image_1
        image_2
        image_3
        image_4
        image_5
        image_6
        image_7
        image_8
        min_number
        max_number
        hour_price
        cash_hour_price
        pay_cash
        pay_points
        business_id
        my_time_stamp
        type{
            id
            name
        }
        location{
            id
            name
            latitude
            longitude
            url
            address
            country
            country_code
            business_id
            location_city{
                id
                name
                county_id
            }
        }
        business{
            id
            name
            logo
        }
    }
}`;

const PITCH_BRAND_QUERY = gql`query{
    brand(where: {is_instructor: {_eq: false}} ,order_by: {id: desc}){
        
        id
        phone
        name
        logo
        is_instructor
        license
        brand_to_brand_categories{
            brand_category{
                id
                name
            }
        }
    }
}`;

const PITCH_CATEGORY_QUERY = gql`query{
    two_pitch_type(order_by:{name: asc}) {
        id
        name
    }
}`;

const OWNER_BUSINESS_QUERY = gql`query($ownerId: Int!){
    business(where:{owner_id: {_eq: $ownerId}}, order_by:{id: desc}) {
        id
        phone
        name
        address
        location_id
        owner_id
        logo
        license
        is_private
        sub_merchant_id
        brand{
            id
            name
            is_instructor
        }
        location{
            id
            name
            latitude
            longitude
            url
            address
            business_id
            location_city{
                id
                name
                county_id
            }
        }
        two_pitches{
            id
            name
            description
            image_1
            image_2
            image_3
            image_4
            image_5
            image_6
            image_7
            image_8
            min_number
            max_number
            hour_price
            business_id
        }
        user_business_points{
            
            points
        }
    }
}`;

const PLAYERS_GROUPS_QUERY = gql`query($nowDate: date!, $playerId: Int!){

    two_play_group(order_by:{updated_at: desc}) {
        id
        name
        uuid
        size
        main_player_id
        players_names
        team_one_names
        team_two_names
        picture
        two_player{
            id
            user_id
            nickname
            phone
            picture
            position_one{
                id
                name
                name_ar
            }
            position_two{
                id
                name
                name_ar
            }
        }
        two_player_to_players_groups(order_by:{two_player: {nickname: asc}}){
            id
            player_id
            team
            two_player{
                id
                nickname
                picture
                position_one{
                    id
                    name
                    name_ar
                }
                position_two{
                    id
                    name
                    name_ar
                }
                user{
                    id
                    phone
                    email
                }
            }
        }
        two_pitch_bookings(where:{day_date: {_gte: $nowDate}}){
            id
            day_date
            start_time
            end_time
            hour_price
            cash_hour_price
            points_cost
            cash_cost
            payment_by_points
            two_player_to_player_transactions(where:{sender_id: {_eq: $playerId}})
            {

                id
                points
            }
            two_pitch_slot{
                id
                two_pitch{
                    id
                    name
                    min_number
                    max_number
                    location{
                        id
                        name
                        latitude
                        longitude
                        url
                        address
                        business_id
                        country
                        country_code
                    }
                }
            }
        }
    }
}`;

const PLAYER_NAME_QUERY = gql`query($playerName: name!){
    two_player(where:{nickname: {_eq: $playerName}}) {
        id
    }
}`;

const PLAYERS_GROUPS_NAME_QUERY = gql`query($groupName: name!){
    two_play_group(where:{name: {_eq: $groupName}}) {
        id
    }
}`;

const PITCH_SLOT_BUSINESS_QUERY = gql`query($tokenId: String!){
    two_pitch_slot(where: {token_id: {_eq: $tokenId}}, order_by:{start_date: asc, start_time: asc}) {
        id
        start_date
        end_date
        start_time
        end_time
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        hour_price
        cash_hour_price
        pay_cash
        pay_points
        males
        females
        two_pitch_bookings{
            id
            day_date
            uuid
            start_time
            end_time
            player_id
            is_manual
            points_cost
            cash_cost
            payment_by_points
            two_player{
                id
                user{
                    id
                    name
                    picture
                    gender
                    date_of_birth
                    phone
                    email
                }
            }
        }
        two_pitch{
            id
            name
            description
            image_1
            image_2
            image_3
            image_4
            image_5
            image_6
            image_7
            image_8
            min_number
            max_number
            hour_price
            type{
                id
                name
            }
            location{
                id
                name
                address
                latitude
                longitude
                url
                business_id
                location_city{
                    id
                    name
                    county_id
                }
            }
            business{
                id
                name
                logo
                is_private
            }
        }
    }
}`;

const PITCH_SLOT_CLIENT_QUERY = gql`query{
    two_pitch_slot(
        where: {two_pitch: {business: {_and:[
            {verified: {_eq: true}},
            {brand: {verified: {_eq: true}}}
        ]}}},
        order_by:{two_pitch: {name: asc}}) {
        id
        start_date
        end_date
        start_time
        end_time
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        hour_price
        cash_hour_price
        pay_cash
        pay_points
        two_pitch_bookings{
            id
            day_date
            uuid
            start_time
            end_time
            points_cost
            cash_cost
            payment_by_points
            two_player{
                id
            }
        }
        two_pitch{
            id
            name
            description
            image_1
            image_2
            image_3
            image_4
            image_5
            image_6
            image_7
            image_8
            min_number
            max_number
            hour_price
            cash_hour_price
            pay_cash
            pay_points
            two_pitch_ratings_aggregate
                {
                    aggregate 
                    {
                        avg {
                            rating
                        }
                    }
                }
            type{
                id
                name
            }
            location{
                id
                name
                address
                latitude
                longitude
                url
                business_id
                location_city{
                    id
                    name
                    ar_name
                    county_id
                    location_country_county{
                        id
                        name
                        ar_name
                    }
                }
            }
            business{
                id
                name
                logo
            }
        }
    }
}`;

const BUSINESS_PITCH_SLOT_CLIENT_QUERY = gql`query($businessId: Int!){
    two_pitch_slot(where:{two_pitch: {business:{id: {_eq: $businessId}}}}, order_by:{two_pitch: {name: asc}}) {
        id
        start_date
        end_date
        start_time
        end_time
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        hour_price
        cash_hour_price
        pay_cash
        pay_points        
        two_pitch_bookings{
            id
            day_date
            uuid
            start_time
            end_time
            points_cost
            cash_cost
            payment_by_points            
            two_player{
                id
            }
        }
        two_pitch{
            id
            name
            description
            image_1
            image_2
            image_3
            image_4
            image_5
            image_6
            image_7
            image_8
            min_number
            max_number
            hour_price
            cash_hour_price
            pay_cash
            pay_points            
            two_pitch_ratings_aggregate
                {
                    aggregate 
                    {
                        avg {
                            rating
                        }
                    }
                }
            type{
                id
                name
            }
            location{
                id
                name
                address
                latitude
                longitude
                url
                business_id
                location_city{
                    id
                    name
                    ar_name
                    county_id
                    location_country_county{
                        id
                        name
                        ar_name
                    }
                }
            }
            business{
                id
                name
                logo
            }
        }
    }
}`;


const TWO_PLAYER_BOOKINGS_QUERY = gql`query($playerId: Int!){

    two_pitch_bookings(where:{two_player:{id: {_eq: $playerId}}}, order_by:{updated_at: desc}){
        id
        day_date
        uuid
        start_time
        end_time
        player_id
        points_cost
        cash_cost
        payment_by_points
        two_pitch_slot{
            id
            start_date
            end_date
            start_time
            end_time
            hour_price
            cash_hour_price
            pay_cash
            pay_points            
            two_pitch{
                id
                name
                description
                image_1
                image_2
                image_3
                image_4
                image_5
                image_6
                image_7
                image_8
                min_number
                max_number
                hour_price
                cash_hour_price
                pay_cash
                pay_points                
                two_pitch_ratings_aggregate
                {
                    aggregate 
                    {
                        avg {
                            rating
                        }
                    }
                }
                type{
                    id
                    name
                }
                business{
                    id
                    name
                    logo
                }
                location{
                    id
                    name
                    address
                    latitude
                    longitude
                    url
                    business_id
                    location_city{
                        id
                        name
                        county_id
                    }
                }
            }
        }
    }
}`;

const PITCH_TYPE_QUERY = gql`query{
    two_pitch_type(order_by:{name: asc}) {
        id
        name
        name_ar
    }
}`;

const RATING_QUERY = gql `query($playerId: Int!){
    
    two_pitch_rating(where: {player_id:{_eq: $playerId}}){
        
        id
        pitch_id
        rating
    }
}
`;


const FOOTBALL_POSITIONS = gql `query{
    
    two_football_position{ 
        id
        name
        name_ar
    }
}`;


const PITCH_PAGE_FULL_QUERY = gql`query($pitchId: Int!){

    two_pitch(where:{id: {_eq: $pitchId}}){
        id
        name
        description
        image_1
        image_2
        image_3
        image_4
        image_5
        image_6
        image_7
        image_8
        min_number
        max_number
        hour_price
        cash_hour_price
        pay_cash
        pay_points        
        two_pitch_ratings_aggregate
            {
                aggregate 
                {
                    avg {
                        rating
                    }
                }
            }
        type{
            id
            name
        }
        location{
            id
            name
            address
            latitude
            longitude
            url
            business_id
            location_city{
                id
                name
                ar_name
                county_id
                location_country_county{
                    id
                    name
                    ar_name
                }
            }
        }
        business{
            id
            name
            logo
        }
    }
    
}`;

const PITCH_WITH_ID_QUERY = gql`query($pitchId: Int!){

    two_pitch(where:{id: {_eq: $pitchId}}){
        id
        name
        description
        image_1
        image_2
        image_3
        image_4
        image_5
        image_6
        image_7
        image_8
        min_number
        max_number
        hour_price
        cash_hour_price
        pay_cash
        pay_points        
        two_pitch_ratings_aggregate
            {
                aggregate 
                {
                    avg {
                        rating
                    }
                }
            }
        type{
            id
            name
        }
        location{
            id
            name
            address
            latitude
            longitude
            url
            business_id
            location_city{
                id
                name
                ar_name
                county_id
                location_country_county{
                    id
                    name
                    ar_name
                }
            }
        }
        business{
            id
            name
            logo
        }
        two_pitch_slots{
            id
            start_date
            end_date
            start_time
            end_time
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
            sunday
            hour_price
            cash_hour_price
            pay_cash
            pay_points            
            two_pitch_bookings{
                id
                day_date
                uuid
                start_time
                end_time
                cash_cost
                points_cost
                payment_by_points
                two_player{
                    id
                }
            }
        }
    }
    
}`;

export default {

    player_and_user_query: PLAYER_AND_USER_QUERY,

    all_pitch_query : ALL_PITCH_QUERY,

    pitch_brand_query: PITCH_BRAND_QUERY,

    pitch_category_query: PITCH_CATEGORY_QUERY,

    owner_business_query: OWNER_BUSINESS_QUERY,

    players_groups_query: PLAYERS_GROUPS_QUERY,

    player_name_query: PLAYER_NAME_QUERY,

    players_groups_name_query: PLAYERS_GROUPS_NAME_QUERY,

    pitch_slot_business_query: PITCH_SLOT_BUSINESS_QUERY,

    pitch_slot_client_query: PITCH_SLOT_CLIENT_QUERY,

    business_pitch_slot_client_query: BUSINESS_PITCH_SLOT_CLIENT_QUERY,

    pitch_type_query: PITCH_TYPE_QUERY,

    two_player_bookings_query: TWO_PLAYER_BOOKINGS_QUERY,

    rating_query: RATING_QUERY,
     
    football_positions: FOOTBALL_POSITIONS,

    pitch_page_full_query: PITCH_PAGE_FULL_QUERY,

    pitch_with_id_query: PITCH_WITH_ID_QUERY
}
